export default __webpack_public_path__ + "static/media/img2.8088e120.svg";